import { Box, Button, Stack } from '@mui/material'

import { ItemThumbnailType } from '@/clients/utoniq-core/schema'
import { ItemReversibleThumbnail, ItemStatusCell } from '@/components/organisms'
import { VoicePlayer } from '@/components/organisms/resourcePlayer/VoicePlayer'
import { ThumbnailActionAreaCell } from '@/components/pages/OwnedItemDetail/template/components/ThumbnailActionArea'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { State } from './'
import { ConsoleItemDescription } from './ConsoleItemDescription'

export type ConsoleItemDetailAvatarProps = {
  loading: boolean
  updating: boolean
  item: State['item']
  isFlipped: boolean
  onSettingAvatar: () => void
  onReverseThumbnail: () => void
  onOpenFullScreen: () => void
  onOpenMultipleImage: () => void
}

export const ConsoleItemDetailAvatar: Cell<ConsoleItemDetailAvatarProps> = ({
  loading,
  updating,
  item,
  onSettingAvatar,
  isFlipped,
  onReverseThumbnail,
  onOpenFullScreen,
  onOpenMultipleImage,
}) => {
  const { t } = useTranslation('consoleItemDetail')
  const voiceResource = item?.avatarResources?.voiceResource
  return (
    <>
      <Box sx={{ position: 'relative' }}>
        <ThumbnailActionAreaCell
          onOpenFullScreen={onOpenFullScreen}
          onOpenMultipleImage={onOpenMultipleImage}
          numberImage={item?.images?.length ?? 0}
        />
        <ItemReversibleThumbnail
          loading={loading}
          flipProps={{ isFlipped }}
          imageAreaProps={{
            thumbnail: item?.thumbnail,
            size:
              item?.thumbnailType === ItemThumbnailType.Square
                ? 'x-large-square'
                : 'x-large',
            onClick: onReverseThumbnail,
          }}
        />
      </Box>
      {item && !loading && (
        <Stack sx={{ pt: 3 }}>
          <ItemStatusCell
            salesCondition={item.salesCondition}
            isPublished={item.isPublished}
            isDrm={item.isDrm}
            isPremium={item.isPremium}
          />
        </Stack>
      )}
      <ConsoleItemDescription item={item} loading={loading} />
      {voiceResource && (
        <Box
          sx={{
            display: 'grid',
            placeItems: 'center',
            py: 4,
          }}
        >
          <VoicePlayer
            resource={voiceResource}
            bgcolor="primary.main"
            color="white"
          />
        </Box>
      )}
      <CellFrame sx={{ py: 2, px: 8, textAlign: 'center' }}>
        <Button
          size="large"
          fullWidth
          onClick={onSettingAvatar}
          loading={updating}
        >
          {t('avatarButtonWord')}
        </Button>
      </CellFrame>
    </>
  )
}
